import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CustomerService } from '../../core/services';
import { CustomerPasswordUpdateModel } from '../../shared/customer.model';
import { ErrorMessage } from '../../shared/error-message.model';
import { Router } from '@angular/router';
import { CustomValidator } from '../../shared/validators';
import { NotificationService } from '../../core/services/notification.service';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss'],
    standalone: false
})
export class ChangePasswordFormComponent implements OnInit {
  @Input() customer;
  @Input() lostPassword = false;
  @Input() token = null;

  customerId: string;

  passwordForm: FormGroup;
  loginError = false;
  loginErrorMessage = '';

  customErrorMessages: ErrorMessage[] = [
    {
      error: 'areEqual',
      format: (label, error) => `${label} does not match`
    },
    {
      error: 'complexity',
      format: (label, error) => `Passwords must be a minimum of 8 characters, maximum of 20 characters and include 1 uppercase letter, 1 lowercase letter and 1 special character`
    }
  ];

  constructor(
    private customerService: CustomerService,
    private formBuilder: FormBuilder,
    private router: Router,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    if (this.lostPassword) {
      this.passwordForm = this.formBuilder.group({
        password: ['', [Validators.required, CustomValidator.validatePasswordsComplexity]],
        confirmPassword: ['', [Validators.required]]
        }, { validator: (formGroup: FormGroup) => {
          return CustomValidator.validatePasswordsAreEqual(formGroup);
        }
      });
    } else {
      this.passwordForm = this.formBuilder.group({
        currentPassword: ['', [Validators.required]],
        password: ['', [Validators.required, Validators.minLength(8),
        Validators.maxLength(20), CustomValidator.validatePasswordsComplexity]],
        confirmPassword: ['', [Validators.required]]
        }, { validator: (formGroup: FormGroup) => {
          return CustomValidator.validatePasswordsAreEqual(formGroup);
        }
      });
    }

    if (this.customer) {
      this.customer.subscribe(customer => {
        if (customer) {
          this.customerId = customer.id;
        }
      });
    }
  }

  onSubmit() {
    if (this.passwordForm.invalid) {
      return;
    }

    if (this.lostPassword) {
      let resetPasswordData = {
        token: this.token,
        password: this.passwordForm.value.password,
      }

      if (this.token) {
        this.customerService.resetPassword(resetPasswordData).subscribe(result => {
          this.notificationService.broadcastSuccessNotification({
            message: 'Successfully updated password.'
          });
          this.router.navigate(['/signin']);
        }, error => {
          console.log("Error: ", error);
          this.notificationService.broadcastFailureNotification({
            message:"Your password reset token has expired. Please resubmit a 'Forgot My Password' request.",
          })
          this.router.navigate(['/signin']);
        });
      }
    } else {
      let apiDataFormat: CustomerPasswordUpdateModel = {
        currentPassword: this.passwordForm.value.currentPassword,
        newPassword: this.passwordForm.value.password,
      }
  
      this.customerService.updatePassword(apiDataFormat).subscribe(result => {
        this.notificationService.broadcastSuccessNotification({
          message: 'Successfully updated password.',
          options: {
            timeout: true
          }
        });
        this.passwordForm.reset();
      }, error => {
        this.notificationService.broadcastFailureNotification({message: error});
      });
    }

  }
}
